export const config = {
    //#region Test CILA 3.0
    // baseURL: 'https://phyathai-api.stech.cloud/',
    // baseURL: 'https://qas-api.cilacademy.com/',
    // baseURL: 'https://localhost:44388/',
    // oneSignalID: '92fef589-7f36-4c9e-9814-6adc4b626cfa',
    // classRoom: 'https://qas-classroom.cilacademy.com/', 
    // myList: 'https://qas-classroom.cilacademy.com/authen?redirect=https://qas-classroom.cilacademy.com/my-courses',
    // classRoom: 'https://qas-classroom.cilacademy.com/',
    // elib: 'https://qas-elib.cilacademy.com/',
    // firebaseID: '',
    // apiType: '1',
    // version: '2.0.0',
    // upToDate: '20/10/2020 15:00',
    // status: 'test'
    //#endregion

    // #region QA
    // baseURL: 'https://qas-api.cilacademy.com/v4/',
    // oneSignalID: '92fef589-7f36-4c9e-9814-6adc4b626cfa',
    // myList: 'https://qas-classroom.cilacademy.com/authen?redirect=https://qas-classroom.cilacademy.com/my-courses',
    // classRoom: 'https://qas-classroom.cilacademy.com/',
    // elib: 'https://qas-elib.cilacademy.com/',
    // firebaseID: '',
    // apiType: '1',
    // version: '3.0.6',
    // upToDate: '06/27/2022 09:00',
    // status: 'qa',
    // x_api_key: 'ncf8xC0GukbUCM6FRz8Q91vTeBlPT7ipdDhGnKYwxC4ZhU0Lce'
    // #endregion

    //#region Prod
    baseURL: 'https://api.cilacademy.com/v4/',
    // oneSignalID: '69307b65-f41e-45b4-b924-b21e44e2e838',
    oneSignalID: 'd8426e75-2774-4b97-b1d4-f9ff5e849d73',
    myList: 'https://classroom.cilacademy.com/authen?redirect=https://classroom.cilacademy.com/my-courses', 
    classRoom: 'https://classroom.cilacademy.com/',
    elib: 'https://elib.cilacademy.com/',
    // firebaseID: '595457635732',
    firebaseID: '681646798648',
    apiType: '1',
    version: '4.0.0',
    upToDate: '03/31/2026 19:00',
    status: 'prod',
    x_api_key: 'EC8GsKofjyz0YB4KRB7LtddZ4NyXmHfOLkDa4m47pjg='
    // #endregion

    //#region Prod
    // baseURL: 'https://api.cilacademy.com/',
    // oneSignalID: '69307b65-f41e-45b4-b924-b21e44e2e838',
    // myList: 'https://classroom.cilacademy.com/authen?redirect=https://classroom.cilacademy.com/my-courses', 
    // classRoom: 'https://classroom.cilacademy.com/',
    // elib: 'https://elib.cilacademy.com/',
    // firebaseID: '595457635732',
    // apiType: '1',
    // version: '3.0.2',
    // upToDate: '12/07/2021 17:38',
    // status: 'prod'
    //#endregion
}
